import React from "react";
import { NavBar } from "antd-mobile";
import { getNavBarContainerStyle } from "../../../../utils/deviceUtils";
import { popBack } from "../../../../utils/appRuntime";
import RouteEndpointsForm from "./components/RouteEndpointsForm";
import { t } from "../../../../i18n";
import { useNativeLangSync } from "../../../../utils/langUtils";

const DeliveryRouteEndpointsSettingNativePage: React.FC = () => {
    useNativeLangSync();
    return (
        <div className="flex flex-col h-screen bg-zinc-100">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                    onBack={popBack}
                    style={{
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        background: '#fff',
                    }}
                >
                    {t("pages.delivery.routeEndpoints.setting.title")}
                </NavBar>
            </div>
            <div className="flex-1 min-h-0">
                <RouteEndpointsForm />
            </div>
        </div>
    );
};

export default DeliveryRouteEndpointsSettingNativePage;
